import {API} from "./axios";

export const ticketsService = {
    getTickets,
    getTicket,
    getTicketActions,
    getTicketCauses,
    addTicket,
    updateTicket,
    delTicket
};

// ####################################################################### GET ALL TICKETS

async function getTickets(params){
    try{
        const res = await API.get(`/tickets`, {params: params});
        return res.data;
    }catch(err){
        if(err.response.status == '403'){
            return Promise.reject("Not Authorized !");
        }else{
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### GET TICKETS

async function getTicket(id){
    try{
        const res = await API.get(`/tickets/${id}`);
        return res.data;
    }catch(err){
        if(err.response.status == '403'){
            return Promise.reject("Not Authorized !");
        }else{
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### Export TICKETs offline XLS

async function getTicketActions(params) {
    try {
        const res = await API.get(`/ticketactions`, {params: params});
        return res.data;
    } catch (err) {
        if (err.response.status == '401' || err.response.status == '403') {
            return Promise.reject("Not Authorized !");
        } else if (err.response.status == '400') {
            return Promise.reject(err.response.data.errors[0].messages[0]);
        } else {
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### Export All TICKETs XLS

async function getTicketCauses(params) {
    try {
        const res = await API.get(`/ticketcauses`, {params: params});
        return res.data;
    } catch (err) {
        if (err.response.status == '401' || err.response.status == '403') {
            return Promise.reject("Not Authorized !");
        } else if (err.response.status == '400') {
            return Promise.reject(err.response.data.errors[0].messages[0]);
        } else {
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### ADD TICKET

async function addTicket(params){
    try{
        const res = await API.post(`/tickets`, params);
        return res.data;
    }catch(err){
        if(err.response.status == '403'){
            return Promise.reject("Not Authorized !");
        }else{
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### UPDATE TICKET

async function updateTicket(params) {
    try{
        let filtredParams = {
            causes: params.causes,
            actions: params.actions,
            status: params.status,
            technicien: params.technicien,
            note: params.note,
            coupure: params.coupure
        };
        const res = await API.patch(`/tickets/${params.ticketId}`, filtredParams);
        return res.data;
    }catch(err){
        if(err.response.status == '401' || err.response.status == '403'){
            return Promise.reject("Not Authorized !");
        }else if(err.response.status == '400'){
            return Promise.reject(err.response.data.errors[0].messages[0]);
        }else{
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}

// ####################################################################### DELETE TICKET

async function delTicket(id){
    try{
        const res = await API.delete(`/tickets/${id}`);
        return res.data;
    }catch(err){
        if(err.response.status == '403'){
            return Promise.reject("Not Authorized !");
        }else if(err.response.status == '404'){
            return Promise.reject("ticket Not Found !");
        }else{
            return Promise.reject("Veuillez réessayer plus tard !");
        }
    }
}